import { render, staticRenderFns } from "./DadosBeneficiario.vue?vue&type=template&id=2bf50315&"
import script from "./DadosBeneficiario.vue?vue&type=script&lang=js&"
export * from "./DadosBeneficiario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports